module.exports = __webpack_public_path__ + "img/code5.1aadebbd.jpg";